export default __webpack_public_path__ + "static/media/Ananth.dc060d08.svg";